import React from 'react';
import {
  DEFAULT_GITHUB_LINKS,
  VEDA_ONLINE_DOCS_URL,
  getExplainersHref,
} from '../../../constants/countryDashboard';

const linkClass = 'text-vervestacks-primary hover:underline text-sm whitespace-nowrap';

/**
 * Same destinations as the country-dashboard header, floated over the home map.
 * No country is selected here, so Veda Online and Explainers use their hub URLs
 * and GitHub uses the default repository (a single link, not a branch menu).
 */
const HomeNavLinks = () => (
  <nav
    aria-label="VerveStacks links"
    className="absolute top-4 right-4 z-30 flex max-w-[46%] flex-col items-end gap-1 sm:max-w-none sm:flex-row sm:items-center sm:gap-x-5"
  >
    <a
      href="https://vedaonline.cloud"
      target="_blank"
      rel="noopener noreferrer"
      className={linkClass}
    >
      Veda Online
    </a>
    <a
      href={VEDA_ONLINE_DOCS_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={linkClass}
    >
      Documentation
    </a>
    <a href={getExplainersHref()} className={linkClass}>
      Explainers
    </a>
    <a
      href={DEFAULT_GITHUB_LINKS.url}
      target="_blank"
      rel="noopener noreferrer"
      className={linkClass}
    >
      GitHub
    </a>
  </nav>
);

export default React.memo(HomeNavLinks);
